import uniqid from 'uniqid'
import moment from 'moment'
import Cookies from 'browser-cookies'
import Fingerprint2 from 'fingerprintjs2'
import isMobile from 'is-mobile'
import store from '@/store'
import axios from 'axios'

const url = (fingerprint, action) => `${process.env.VUE_APP_API_URL}/client-path/fingerprints/${fingerprint}/${action}`

var deviceInspector = {
  options: [],
  header: [navigator.platform, navigator.userAgent, navigator.appVersion, navigator.vendor, window.opera],
  dataos: [
    { name: 'Windows Phone', value: 'Windows Phone', version: 'OS' },
    { name: 'Windows', value: 'Win', version: 'NT' },
    { name: 'iPhone', value: 'iPhone', version: 'OS' },
    { name: 'iPad', value: 'iPad', version: 'OS' },
    { name: 'Kindle', value: 'Silk', version: 'Silk' },
    { name: 'Android', value: 'Android', version: 'Android' },
    { name: 'PlayBook', value: 'PlayBook', version: 'OS' },
    { name: 'BlackBerry', value: 'BlackBerry', version: '/' },
    { name: 'Apple', value: 'Mac', version: 'OS X' },
    { name: 'Linux', value: 'Linux', version: 'rv' },
    { name: 'Palm', value: 'Palm', version: 'PalmOS' }
  ],
  databrowser: [
    { name: 'Chrome', value: 'Chrome', version: 'Chrome' },
    { name: 'Firefox', value: 'Firefox', version: 'Firefox' },
    { name: 'Safari', value: 'Safari', version: 'Version' },
    { name: 'Internet Explorer', value: 'MSIE', version: 'MSIE' },
    { name: 'Opera', value: 'Opera', version: 'Opera' },
    { name: 'BlackBerry', value: 'CLDC', version: 'CLDC' },
    { name: 'Mozilla', value: 'Mozilla', version: 'Mozilla' }
  ],
  get: function () {
    var agent = this.header.join(' ')
    var os = this.matchItem(agent, this.dataos)
    var browser = this.matchItem(agent, this.databrowser)
    // var isMobile = isMobile()

    return { os: os, browser: browser, isMobile: isMobile() }
  },
  matchItem: function (string, data) {
    var i = 0
    var j = 0
    var regex
    var regexv
    var match
    var matches
    var version

    for (i = 0; i < data.length; i += 1) {
      regex = new RegExp(data[i].value, 'i')
      match = regex.test(string)
      if (match) {
        regexv = new RegExp(data[i].version + '[- /:;]([\\d._]+)', 'i')
        matches = string.match(regexv)
        version = ''
        if (matches) { if (matches[1]) { matches = matches[1] } }
        if (matches) {
          matches = matches.split(/[._]+/)
          for (j = 0; j < matches.length; j += 1) {
            if (j === 0) {
              version += matches[j] + '.'
            } else {
              version += matches[j]
            }
          }
        } else {
          version = '0'
        }
        return {
          name: data[i].name,
          version: parseFloat(version)
        }
      }
    }
    return { name: 'unknown', version: 0 }
  }
}

export default {
  init() {
    try {
      const getFingerprint = () => {
        return new Promise((resolve) => {
          if (!Cookies.get('si_fp')) {
            Fingerprint2.get(components => {
              let fingerprint = Fingerprint2.x64hash128(components.map(function (pair) { return pair.value }).join(), 31)
              resolve(fingerprint)
            })
          } else {
            resolve(Cookies.get('si_fp'))
          }
        })
      }

      const setCookie = async (fingerprint) => {
        if (!Cookies.get('si_fp')) {
          let dateId = moment().format('YYYYMMDD')

          Cookies.set('si_fp', fingerprint, { expires: 3000 })
          await axios.post(url(fingerprint, 'visit'), { dateId })
        }
      }

      const setSessionId = () => {
        if (!sessionStorage.getItem('si_sid')) {
          sessionStorage.setItem('si_sid', uniqid())
        }
      }

      const setDeviceInfo = async (fingerprint) => {
        const device = deviceInspector.get()

        let deviceInfo = {
          os: device.os.name,
          osVersion: device.os.version,
          browser: device.browser.name,
          browserVersion: device.browser.version,
          isMobile: device.isMobile
        }

        store.commit('set_userDevice', deviceInfo)

        await axios.post(url(fingerprint, 'device'), { deviceInfo })
        return deviceInfo
      }

      const setUserLocation = async (fingerprint) => {
        const includeInHash = ['city, country_name', 'postal', 'state']
        const location = await axios.get('https://geoip-db.com/json/geoip.php').then(r => r.data)
        const locationHash = Fingerprint2.x64hash128(Object.keys(location).filter(k => includeInHash.includes(k)).map(k => location[k]).join(), 31)

        store.commit('set_userLocation', location)

        await axios.post(url(fingerprint, 'location'), { location, locationHash })

        return location
      }

      const run = async () => {
        let fingerprint = await getFingerprint()
        store.commit('set_fingerprint', fingerprint)

        setUserLocation(fingerprint)

        setDeviceInfo(fingerprint)

        setCookie(fingerprint)

        setSessionId(fingerprint)

        store.commit('set_clientPathInit', true)
      }

      if (window.requestIdleCallback) {
        requestIdleCallback(() => { run() })
      } else {
        setTimeout(() => { run() }, 500)
      }
    } catch (e) {
      console.error('ERROR [init]: ', e)
    }
  },
  track(interactionCode, metaData = null) {
    try {
      const writeTrack = () => {
        if (!store.getters._clientPathInit) {
          return setTimeout(() => { writeTrack() }, 1000)
        }

        let fingerprint = store.getters._fingerprint
        let sessionId = sessionStorage.getItem('si_sid')
        let timestamp = new Date().toISOString()
        let interaction = {
          ts: timestamp,
          i: interactionCode,
          sid: sessionId,
          meta: metaData
        }
        axios.post(url(fingerprint, 'track'), { timestamp, interaction, interactionCode })
      }
      writeTrack()
    } catch (e) {
      console.error('ERROR [track]: ', e)
    }
  },
  identify(email, name = null) {
    try {
      let fingerprint = store.getters._fingerprint

      axios.post(url(fingerprint, 'identify'), { email, name })
    } catch (e) {
      console.error('ERROR [identify]: ', e)
    }
  },
  tag(tags) {
    try {
      const writeTag = () => {
        if (!store.getters._clientPathInit) return setTimeout(() => { writeTag() }, 1000)
        if (!tags) return
        if (tags.constructor !== Array) tags = [tags]

        let fingerprint = store.getters._fingerprint

        axios.post(url(fingerprint, 'tag'), { tags })
      }
      writeTag()
    } catch (e) {
      console.error('ERROR [tag]: ', e)
    }
  },
  trackReferer() {
    let referrer = document.referrer || ''

    if (referrer) {
      referrer = referrer.split('?')[0]
      axios.post(`${process.env.VUE_APP_API_URL}/client-path/referrer`, { referrer })
    }
  }
}
